import { render, staticRenderFns } from "./StatementComponent.vue?vue&type=template&id=8d63afd8"
import script from "./StatementComponent.vue?vue&type=script&lang=js"
export * from "./StatementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports